import React, { useEffect, useState } from "react";
import {
  Card,
  Form,
  Row,
  Col,
  Input,
  Button,
  Modal,
  message,
  Spin,
} from "antd";
import { API_METHODS } from "../constants";
import useApi from "../hooks/useApi";

function DeleteData() {
  const [form] = Form.useForm();
  const [validateOTPResponse, validateOTPRequest] = useApi(
    "/delete-account/validate-otp",
    null,
    API_METHODS.POST
  );
  const [deleteAccountResponse, deleteAccountRequest] = useApi(
    "/delete-account",
    null,
    API_METHODS.POST
  );
  const [showOTPModal, setShowOTPModal] = useState(false);
  const [loading, setLoading] = useState(false); // Add loading state

  useEffect(() => {
    if (deleteAccountResponse.data) {
      setShowOTPModal(true);
      setLoading(false); // Stop loading when OTP is requested
    }
    if (deleteAccountResponse.error) {
      setLoading(false); // Stop loading on error
    }
  }, [deleteAccountResponse]);

  useEffect(() => {
    if (validateOTPResponse.data) {
      message.success("Account deleted successfully.");
      form.resetFields(); // Reset the form
      setShowOTPModal(false); // Close the OTP modal
      setLoading(false); // Stop loading
    }
    if (validateOTPResponse.error) {
      setLoading(false); // Stop loading on error
    }
  }, [validateOTPResponse]);

  const onFinish = (values) => {
    setLoading(true); // Start loading
    if (showOTPModal) {
      validateOTPRequest(values);
    } else {
      Modal.confirm({
        title: "Confirm Account Deletion",
        content:
          "Are you sure you want to permanently delete your account and all associated data? This action cannot be undone.",
        okText: "Yes, Delete My Account",
        cancelText: "No, Cancel",
        onOk: () => {
          deleteAccountRequest(values);
        },
        onCancel: () => {
          setLoading(false); // Stop loading if cancelled
        },
      });
    }
  };

  const handleOTPModalOk = () => {
    form
      .validateFields()
      .then((values) => {
        setLoading(true); // Start loading when OTP is submitted
        validateOTPRequest(values);
      })
      .catch((errorInfo) => {
        // Validation failed, do nothing (Ant Design handles this)
      });
  };

  return (
    <div>
      <Card title="Delete Account">
        <Form layout="vertical" form={form} onFinish={onFinish}>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="email_id"
                label="Email"
                rules={[{ required: true, message: "Email is required." }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item style={{ float: "right" }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading && !showOTPModal} // Show loading for initial request
            >
              {loading && !showOTPModal ? "Deleting..." : "Delete Account"}
            </Button>
          </Form.Item>
        </Form>
      </Card>

      <Modal
        title="Enter OTP"
        visible={showOTPModal}
        onOk={handleOTPModalOk}
        onCancel={() => {
          setShowOTPModal(false);
          form.resetFields(["otp"]); // Clear OTP field
        }}
        confirmLoading={loading && showOTPModal} // Show loading for OTP submission
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={form.getFieldsValue()} // Retain email
        >
          <Form.Item
            name="otp"
            label="OTP"
            rules={[{ required: true, message: "OTP is required." }]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default DeleteData;
